import { keyEnumObject, ValueTypeOf } from '@berlin-front/common/utils';

/**
 * ヘッダー種別の情報。
 */
export const HEADER_MAP = {
  titleOnly: 'title-only',
  shopTitle: 'shop-title',
  shopPrice: 'shop-price',
  none: 'none',
} as const;

/**
 * アラート種別定数。
 */
export const HEADER_TYPE = keyEnumObject(HEADER_MAP);

/**
 * アラート種別の型。
 */
export type HeaderType = ValueTypeOf<typeof HEADER_TYPE>;
